export default {
      id: "arrow-right-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "sprite.svg#arrow-right",
      toString: function () {
        return this.url;
      }
    }